import { useState } from "react";

function Otp() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [mode, setMode] = useState("1");
  const [auto, setAuto] = useState("1");
  const [messageId, setMessageId] = useState("");
  const [response, setResponse] = useState("");
  const [isMobileNumberFilled, setIsMobileNumberFilled] = useState(false);
  const [isOtpFilled, setIsOtpFilled] = useState(false);
  const [isMessageIdFilled, setIsMessageIdFilled] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    let selectedModes = [];

    if (auto === "1") {
      // If automatic OTP journey is selected, set all modes (1, 2, 3)
      selectedModes = [123];
    } else {
      // If manual OTP journey is selected, add only the selected mode to the array
      selectedModes.push(mode);
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "AX7YM1XDhi4pvALJV4OGS5ZNbgkW6WKT1VQnbGQR",
        authorizationToken: "KbZsMsZK3MVoa3W2",
      },
      body: JSON.stringify({
        MOBILE_NUMBER: mobileNumber,
        OTP: otp,
        MODE: selectedModes.join(","), // Join the modes array into a comma-separated string
        AUTO: auto,
        MESSAGE_ID: messageId,
      }),
    };

    try {
      const response = await fetch(
        "https://38uicqbx94.execute-api.ap-south-1.amazonaws.com/default/AINXT_OTP_GATEWAY",
        requestOptions
      );
      const data = await response.json();
      setResponse(JSON.stringify(data));
    } catch (error) {
      console.error(error);
    }
  };
  const handleMobileNumberChange = (event) => {
    const input = event.target.value;
    if (/^\d{0,10}$/.test(input)) {
      setMobileNumber(input);
      setIsMobileNumberFilled(input.length === 10);
    }
  };
  const handleMessageIdChange = (event) => {
    const input = event.target.value;
    setMessageId(input);
    setIsMessageIdFilled(input.length > 0);
  };
  const handleOtpChange = (event) => {
    const input = event.target.value.replace(/\D/g, ''); // replace all non-digits with empty string
    const maxLength = 6;
    const truncatedInput = input.slice(0, maxLength); // truncate input to maxLength
  
    setOtp(truncatedInput);
    setIsOtpFilled(truncatedInput.length === maxLength);
  };


  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px', borderRadius: '5px', marginLeft: '50px', height: '500px', overflowY: 'auto'}}>
  <h2 style={{textAlign: 'center', marginBottom: '30px'}}>OTP Form</h2>
  <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
  <label style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px', color: '#000000'}}>
  <input
    type="radio"
    checked={auto === "1"}
    onChange={() => setAuto("1")}
    style={{marginLeft: '10px'}}
  />
  <span style={{marginLeft: '5px'}}>Automatic OTP journey</span>
</label>
<label style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px', color: '#000000'}}>
  <input
    type="radio"
    checked={auto === "2"}
    onChange={() => setAuto("2")}
    style={{marginLeft: '10px'}}
  />
  <span style={{marginLeft: '5px'}}>Manual OTP journey</span>
</label>
    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '10px', color:"#000000"}}>
      Mobile Number:
      <input
        type="tel"
        value={mobileNumber}
        onChange={handleMobileNumberChange}
        maxLength={10}
        pattern="[0-9]{10}"
        style={{marginLeft: '10px'}}
      />
    </label>
    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '10px', color: '#000000'}}>
      OTP:
      <input
        type="text"
        value={otp}
        onChange={handleOtpChange}
        style={{marginLeft: '10px'}}
      />
    </label>
    {auto === "2" && (
      <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '10px', color: '#000000'}}>
        Mode:
        <select value={mode} onChange={(event) => setMode(event.target.value)} style={{marginLeft: '10px'}}>
          <option value="1">OTP through SMS</option>
          <option value="2">OTP through Whatsapp Message</option>
          <option value="3">OTP through Call</option>
        </select>
      </label>
    )}
    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '10px', color: '#000000'}}>
      Message ID:
      <input
        type="text"
        value={messageId}
        onChange={(event) => setMessageId(event.target.value)}
        style={{marginLeft: '10px'}}
      />
    </label>
    <button type="submit" className="btn btn-primary mob-w-100 " style={{marginTop: '20px', padding: '10px 20px'}} disabled={!mobileNumber || !otp || !messageId}>Submit</button>
  </form>
  {response && <div style={{marginTop: '20px', backgroundColor: '#ECECEC', padding: '10px', borderRadius: '5px'}}>{response}</div>}
</div>
  
  );
}

export default Otp;
